// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields)
	{
		if (validFields[name] === false)
		{
			return false;
		}
	}

	if (fields.company_business.length <= 0 ||
		fields.customer_comp_histresult1.length <= 0 ||
		fields.customer_comp_histresult2.length <= 0 ||
		fields.customer_comp_histresult3.length <= 0 ||
		fields.customer_comp_budresult12m.length <= 0 ||
		fields.customer_comp_budresult24m.length <= 0 ||
		fields.customer_comp_assets_cash.length <= 0 ||
		fields.customer_comp_assets_fininstr.length <= 0 ||
		fields.customer_comp_assets_other.length <= 0 ||
		fields.customer_comp_assets_sum.length <= 0 ||
		!fields.ubo_fields_valid)
	{
		return false;
	}

	if (!fields.typeOfCompanyFulfilled ||
		!fields.numberOfEmployeesFulfilled ||
		!fields.sizeOfTurnoverFulfilled ||
		!fields.originOfCompanyFundsFulfilled ||
		!fields.sizeOfDepositsFulfilled ||
		!fields.frequencyOfDepositsFulfilled)
	{
		return false;
	}

	if (!(fields.radio_company_fininst.options[0].checked || fields.radio_company_fininst.options[1].checked) ||
		!(fields.radio_company_active.options[0].checked || fields.radio_company_active.options[1].checked) ||
		!(fields.radio_company_revisor.options[0].checked || fields.radio_company_revisor.options[1].checked))
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Kyc/KycForetag.fulfillment.js